var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeenCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    fill: "white",
    stroke: "#ED5272"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_652_1386",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 61,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.4668,
    y: 18.1982,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_652_1386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7795 65.2205C28.6609 63.1019 27.0013 60.6537 25.8008 57.876C24.6003 55.0983 24 52.2264 24 49.2604C24 46.2943 24.565 43.3636 25.6949 40.4682C26.8248 37.5728 28.6609 34.8539 31.2032 32.3116C34.028 29.4868 38.0181 27.3446 43.1733 25.8852C48.3286 24.4257 55.0022 23.8136 63.1941 24.049C64.4182 24.0961 65.5481 24.3551 66.5838 24.8259C67.6196 25.2967 68.5377 25.9322 69.338 26.7326C70.1384 27.533 70.774 28.4628 71.2448 29.5221C71.7156 30.5814 71.9745 31.7231 72.0216 32.9472C72.1157 36.8077 72.0098 40.374 71.7038 43.6461C71.3978 46.9181 70.9034 49.8724 70.2208 52.5089C69.5381 55.1454 68.6671 57.4876 67.6078 59.5356C66.5485 61.5836 65.2891 63.3373 63.8297 64.7968C61.3344 67.292 58.6862 69.1163 55.8849 70.2698C53.0837 71.4233 50.2235 72 47.3046 72C44.2444 72 41.2548 71.3997 38.3359 70.1992C35.4169 68.9986 32.8981 67.3391 30.7795 65.2205ZM38.689 64.0906C40.0543 64.8909 41.4549 65.4677 42.8908 65.8208C44.3268 66.1739 45.798 66.3504 47.3046 66.3504C49.4703 66.3504 51.6124 65.9149 53.731 65.0439C55.8496 64.173 57.874 62.7723 59.8043 60.842C60.6518 59.9946 61.511 58.8058 62.382 57.2757C63.2529 55.7456 64.0062 53.7447 64.6418 51.273C65.2774 48.8013 65.7599 45.8118 66.0895 42.3043C66.4191 38.7968 66.4661 34.6185 66.2307 29.7693C63.9238 29.6751 61.3227 29.6398 58.4272 29.6633C55.5318 29.6869 52.6482 29.9105 49.7763 30.3342C46.9044 30.7579 44.1738 31.4406 41.5844 32.3822C38.995 33.3238 36.8764 34.6185 35.2286 36.2663C33.11 38.3849 31.6505 40.48 30.8501 42.5515C30.0498 44.623 29.6496 46.6239 29.6496 48.5542C29.6496 51.3319 30.1792 53.7683 31.2385 55.8633C32.2978 57.9584 33.2277 59.4296 34.028 60.2771C36.0054 56.5107 38.6183 52.8973 41.8669 49.4369C45.1154 45.9765 48.9053 43.14 53.2367 40.9272C49.8469 43.8933 46.8926 47.2477 44.3739 50.9906C41.8551 54.7334 39.9601 59.1001 38.689 64.0906Z",
    fill: "#ED5272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeenCover);
export default __webpack_public_path__ + "static/media/GeenCover.8edb07403513b74f990b098cebb19d78.svg";
export { ForwardRef as ReactComponent };